import React from 'react'
import { Form, Button, Message, Input, Segment, Header } from 'semantic-ui-react'

export default class FormLogin extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            name: '',
            username: '',
            password: '',
            repPassword: '',
            nameGame:'', 
            isRegister: false,
            isPlaying: false,
            canRegister: false,
            isPrivate: true, 
            isResetPassword:false
        }
    }

    handleRef = component => this.userNameField = component

    componentDidMount() {
        //this.userNameField.focus()
    }

    register() {
        const { username, name, password } = this.state
        this.props.onRegister({ email: username, username: name, password })
        this.setState({name:'', username:'',password:'', repPassword:''})
    }

    resetPassword() {
        const { username } = this.state
        this.props.onResetPassword({ email: username})
        this.setState({name:'', username:'',password:'', repPassword:''})
    }

    login() {
        const { name, username, password } = this.state
        this.props.onLogin({ name, username, password })
    }

    temporaryLogin(){
        const {username, nameGame} = this.state
        const password = 'temporarypassword'
        this.props.onTemporaryLogin({username, password, nameGame})
    }

    onSubmit = (e) => {
        const { isRegister, isPrivate, isResetPassword } = this.state
        e.preventDefault()
        if (isPrivate)
            this.temporaryLogin()
        else
            if (isRegister)
                this.register()
        else
            if (isResetPassword)
                    this.resetPassword()
        else
            this.login()
        return false
    }

    handleFormClick = () => {
        if (this.state.isPlaying)
            return
        this.setState({ isPlaying: true })
    }

    handleToggleRegisterClick = () => {
        this.setState({ isRegister: !this.state.isRegister })
        this.userNameField.focus()
    }

    handleTogglePasswordReset = () => {
        this.setState({ isResetPassword: !this.state.isResetPassword })
        this.userNameField.focus()
    }

    handleTogglePrivateClick = () => {
        this.setState({ isPrivate: !this.state.isPrivate })
        this.userNameField.focus()
    }

    handleChange = (e, { name, value }) => this.setState({ [name]: value })
    onNameChange = (e) => this.setState({ username: e.target.value })
    onPasswordChange = (e) => {
        this.setState({ password: e.target.value })
        if (this.state.repPassword === e.target.value)
            this.setState({ canRegister: true})
        else this.setState({ canRegister: false})
    }
    onRepeatPasswordChange = (e) => {
        this.setState({ repPassword: e.target.value })
        if (this.state.password === e.target.value)
            this.setState({ canRegister: true})
        else this.setState({ canRegister: false})
    }

    onNameGameChange = (e) => {
        this.setState({ nameGame: e.target.value })
    }

    render() {
        const { error, loading } = this.props
        const { name, username, password, isRegister, canRegister, repPassword, isPrivate, nameGame, isResetPassword} = this.state
        
        return (
            <Form onSubmit={this.onSubmit} loading={loading} onClick={this.handleFormClick}>
                <Header as='h2'>{isRegister ? 'Registrati' : 
                                 isResetPassword? 'Reset Password':
                                 isPrivate? 'Accedi':
                                 'Admin Info'}</Header>
                {error ? <Message negative><p>{error}</p></Message> : ''}
                        {isRegister?
                        <body>
                            <Segment>
                            <Form.Field>
                                <Input ref={this.handleRef} name='username' value={username} onChange={this.onNameChange} 
                                placeholder={ 'Email'} icon='at' iconPosition='left' />
                                </Form.Field>
                                <Form.Field>
                                <Input icon='user' iconPosition='left' placeholder='Nome' name='name' value={name} onChange={this.handleChange} />
                                </Form.Field>
                                <Form.Input type="password" name='password' value={password} onChange={this.onPasswordChange}
                                placeholder="Password" icon='lock' iconPosition='left' />
                                <Form.Input type="password" name='repPassword'value={repPassword}  onChange={this.onRepeatPasswordChange}
                                placeholder="Repeat your password" icon='lock' iconPosition='left' />
                                <Button fluid primary disabled = {!canRegister} type="submit">{'Registrati'}</Button>
                            </Segment>
                                <p> <a href='javascript:void(0)' onClick={this.handleToggleRegisterClick}>Hai già un account?</a></p>
                            </body>
                         :null}
                        {isPrivate?
                        <body>
                            <Segment>
                                <Form.Field>
                                <Input ref={this.handleRef} name='username' value={username} onChange={this.onNameChange} 
                                placeholder={ 'Username o Email'} icon='at' iconPosition='left' />
                                </Form.Field>
                                <Form.Input name='nameGame'value={nameGame}  onChange={this.onNameGameChange}
                                placeholder="Nome della partita" icon='key' iconPosition='left' />
                                <Button fluid primary  type="submit">{'Accedi'}</Button>
                            </Segment>
                            <p><a href='javascript:void(0)' onClick={this.handleTogglePrivateClick}>Admin info </a></p>
                        </body>
                        :null}
                        {isResetPassword?
                         <body>
                            <Segment>
                                <Form.Field>
                                <Input ref={this.handleRef} name='username' value={username} onChange={this.onNameChange} 
                                placeholder={'Username o Email'} icon='at' iconPosition='left' />
                                </Form.Field>   
                                <Button fluid primary  type="submit">{'Reset password'}</Button>
                            </Segment>
                            <p><a href='javascript:void(0)' onClick={this.handleTogglePasswordReset}>Torna al Login </a></p>
                        </body>
                       :null}
                        {!isResetPassword && !isPrivate && !isRegister?
                         <body>
                            <Segment>
                            <Form.Field>
                                <Input ref={this.handleRef} name='username' value={username} onChange={this.onNameChange} 
                                placeholder={ 'Email'} icon='at' iconPosition='left' />
                                </Form.Field>
                                <Form.Input type="password" name='password' value={password} onChange={this.onPasswordChange}
                                    placeholder="Password" icon='lock' iconPosition='left' />
                                <Button fluid primary  type="submit">{'Accedi'}</Button>
                            </Segment>
                            <p><a href='javascript:void(0)' onClick={this.handleTogglePrivateClick}>Clicca qui per tornare alla partita privata </a></p>
                            </body>
                        :null}
            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FormLogin.js